import React, { useState } from "react";
import styles from "./Counter.module.css";
import { useDispatch } from "react-redux";
import {
  addItemOrQtyToCart,
  removeProductQuantity,
  removeItemFromCart,
} from "../../redux/userSlice";

function Counter({ initial, product, setStockAlert }) {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(initial);

  const stockAlert = () => {
    if (quantity === product.stock) {
      setStockAlert(true);
      setTimeout(() => setStockAlert(false), 5000);
    }
  };
  return (
    <div className="d-flex">
      <div className="">
        <button
          type="button"
          className={styles.btn_minus}
          onClick={() => {
            setStockAlert(false);
            setQuantity((prevState) => {
              if (prevState <= 1) return prevState;
              return prevState - 1;
            });
            if (quantity <= 1) {
              dispatch(removeItemFromCart(product));
            } else {
              dispatch(removeProductQuantity(product));
            }
          }}
        >
          <i className={"fa-solid fa-less-than " + styles.icons}></i>
        </button>
      </div>
      <div className={styles.counter_value}>{quantity}</div>
      <div className="d-flex align-items-center">
        <button
          type="button"
          className={styles.btn_plus}
          onClick={() => {
            stockAlert();
            setQuantity((prevState) => {
              if (prevState < product.stock) {
                return Number(prevState) + 1;
              }
              return prevState;
            });
            dispatch(addItemOrQtyToCart(product));
          }}
        >
          <i className={"fa-solid fa-greater-than " + styles.icons}></i>
        </button>
      </div>
    </div>
  );
}

export default Counter;
